export const refreshPage = ()=>{window.location.reload(true);}

export const isSameSenderMargin = (messages, m, i, userId) => {
  // console.log(i === messages.length - 1);

  if (
    i < messages.length - 1 &&
    messages[i + 1].sender._id === m.sender._id &&
    messages[i].sender._id !== userId
  )
    return 33;
  else if (
    (i < messages.length - 1 &&
      messages[i + 1].sender._id !== m.sender._id &&
      messages[i].sender._id !== userId) ||
    (i === messages.length - 1 && messages[i].sender._id !== userId)
  )
    return 0;
  else return "auto";
};

export const isSameSender = (messages, m, i, userId) => {
  // console.log("[isSameSender data test] messages:",messages,"| m:",m,"| i:", i,"| userId:",userId)

  return (
    i < messages.length - 1 &&
    (messages[i + 1].sender._id !== m.sender._id ||
      messages[i + 1].sender._id === undefined) &&
    messages[i].sender._id !== userId
  );
};

export const isLastMessage = (messages, i, userId) => {
  // console.log("lastMessage",messages[messages.length - 1])
  return (
    i === messages.length - 1 &&
    messages[messages.length - 1].sender._id !== userId &&
    messages[messages.length - 1].sender._id
  );
};

export const isSameUser = (messages, m, i) => {
  return i > 0 && messages[i - 1].sender._id === m.sender._id;
};

export const getSender = (loggedUser, users,chat_id) => {
  console.log("[getSender data test] loggedUser:",loggedUser?.preferredName,"users[0].preferredName:",users[0]?.preferredName,"users[1]:",users[1]?.preferredName,"chat_id:",chat_id)
  // console.log("users[*].preferredName:",users[0]?.preferredName)
  try{ return (users[0]?._id === loggedUser._id) ? users[1]?.preferredName : users[0]?.preferredName}
  catch (error) {
    // refreshPage()
    console.log('[get sender error] loggedUser: ',loggedUser,'users: ', users )
  }
  
}

export const getSenderFull = (loggedUser, users) => {
  return users[0]._id === loggedUser._id ? users[1] : users[0];
};